module.exports = __webpack_public_path__ + "static/media/editTag_default.303f4218.svg";